import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";


const vUI_Periodh_Search_Fields: {[id:string]: ISearchProviderField } = {

    WB_PERIODH_ID:           {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Periodh Id', columnResourceName: 'colId', alignment: HorizAlignment.Right}, domainOptions: {}},
    WB_PERIOD_HIER_ID:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Period Hier Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PERIOD_HIERARCHY_TYPE:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Period Hierarchy Type', columnResourceName: 'colPeriodHierarchyType', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    TPM_PERIOD_HIER_ROW_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'TPM Period Hier Row ID', columnResourceName: 'colTpmPeriodHierId', alignment: HorizAlignment.Left}, domainOptions: {}},
    SOURCE_ID:  {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Source Id', columnResourceName: 'colSourceId', alignment: HorizAlignment.Left}, domainOptions: {}},
    WB_PERIOD_HIER_NAME:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Period Hier Name', columnResourceName: 'colPeriodHierName', alignment: HorizAlignment.Left}, domainOptions: {}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
};

const PeriodHierarchySearchProviderBasic: ISearchProvider = {

    keyFields: {
        id: 'WB_PERIODH_ID',
        id_ui: 'WB_PERIOD_HIER_ID',
        name: 'WB_PERIOD_HIER_NAME'
    },

    searchProviderFields: vUI_Periodh_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            const findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Period_Hierarchy_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res);
                })
                .catch((err) => {
                    error(err);
                })
        })
    }

};

const PeriodHierarchySearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "By Id, Name",
    renderOptions: {ui5ResourceId: "PeriodHierarchySearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'WB_PERIOD_HIER_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'WB_PERIOD_HIER_NAME', renderOptions: {}}
    ],  // ISearchFields
    profileDisplayFields: [
        'WB_PERIOD_HIER_ID', 'PERIOD_HIERARCHY_TYPE', 'TPM_PERIOD_HIER_ROW_ID', 'SOURCE_ID', 'WB_PERIOD_HIER_NAME',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: PeriodHierarchySearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const PeriodHierarchySearch: ISearch = {
    searchName: "Find Period Hierarchy",
    renderOptions: {ui5ResourceId: "PeriodHierarchySearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [PeriodHierarchySearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("PeriodHierarchyBO", "PeriodHierarchy", PeriodHierarchySearch, "Period Hierarchy Search")

export {PeriodHierarchySearch}